import dispatcher from '../dispatcher';

var elementProto = Object.create(HTMLSelectElement.prototype);

var _setValue = function(value, noEvent) {
	var valid = false;

	Array.prototype.forEach.call(this._options, function(op) {
		if (op.value === value) {
			valid = true;
		}
	});

	if (valid) {
		this.value = value;
	} else {
		this.value = this._defaultValue;
	}
}

var _getData = function() {
	return {
		value: this.value,
		default: this._defaultValue
	}
}

var _setData = function(data) {
	if (data.value) {
		this.setValue(data.value);
	}
}

var _reset = function() {
	this.setValue(this._defaultValue);
}

var _handleDispatcher = function(e) {
	if (e.type === 'select:setValue' &&
		e.id === this._id) {
		this.setValue(e.value);
	}
}

elementProto.createdCallback = function() {
	this.reset = _reset.bind(this);
	this.getData = _getData.bind(this);
	this.setData = _setData.bind(this);
	this.setValue = _setValue.bind(this);
	this.handleDispatcher = _handleDispatcher.bind(this);
}
elementProto.attachedCallback = function() {
	this._id = this.getAttribute('data-id');
	this._options = this.getElementsByTagName('option');
	this._defaultValue = this._options[0].value;

	dispatcher.subscribe(this.handleDispatcher);

	this.addEventListener('change', function(e) {
		var option = this.options[this.selectedIndex];
		var disabled = option.hasAttribute('disabled');

		if (!disabled) {
			this.classList.add('valid');
		}
	});
}
elementProto.detachedCallback = function() {
	dispatcher.unsubscribe(this.handleDispatcher);
}

document.registerElement('simple-select', {
	prototype: elementProto,
	extends: 'select'
});